"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
export class PayPalBind extends UiFormController {
  constructor() {
    super(...arguments);
    this.paypal_account = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "change_paypal_account_dialog.paypal_account_require"
      ),
      trigger: "blur"
    },
    {
      validator: (rule, value, callback) => {
        if (value !== null && value !== void 0 && value !== "") {
          let runoob = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          let message = rule.hasOwnProperty("message") ? rule.message : i18n.t("change_paypal_account_dialog.paypal_account_format");
          let search = value.search(runoob);
          if (value !== "" && search < 0) {
            callback(message);
            return false;
          }
        }
        callback();
        return true;
      },
      message: i18n.t(
        "change_paypal_account_dialog.paypal_account_format"
      ),
      trigger: "blur"
    }
  ])
], PayPalBind.prototype, "paypal_account", 2);
export class PayPalVerify extends UiFormController {
  constructor() {
    super(...arguments);
    this.code = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "change_paypal_account_dialog.paypal_code_require"
      ),
      trigger: "blur"
    },
    {
      validator: (rule, value, callback) => {
        if (value !== null && value !== void 0 && value !== "") {
          let runoob = /^\d{6}$/;
          let message = rule.hasOwnProperty("message") ? rule.message : i18n.t("change_paypal_account_dialog.paypal_code_format");
          let search = value.search(runoob);
          if (value !== "" && search < 0) {
            callback(message);
            return false;
          }
        }
        callback();
        return true;
      },
      message: i18n.t(
        "change_paypal_account_dialog.paypal_code_format"
      ),
      trigger: "blur"
    }
  ])
], PayPalVerify.prototype, "code", 2);
let ChangePayPalAccountDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.payPalBind = new PayPalBind();
    this.payPalVerify = new PayPalVerify();
    this.unbind = true;
    //是否绑定过
    this.to_verify = false;
  }
  //是否进入验证阶段
  open() {
    return __async(this, null, function* () {
      this._change_paypal_account_dialog.show();
      this.payPalBind.paypal_account = this._controller.paypal_account;
      this.unbind = !this.payPalBind.paypal_account;
    });
  }
  close() {
    var _a, _b;
    (_a = this._pay_pal_bind) == null ? void 0 : _a._form.resetFields();
    (_b = this._pay_pal_verify) == null ? void 0 : _b._form.resetFields();
    this.unbind = false;
    this.to_verify = false;
    this._change_paypal_account_dialog.hide();
    this.$emit("stopLoading");
  }
  sendCode() {
    return __async(this, null, function* () {
      try {
        let params = {
          type: "paypal.account.change.code",
          email: this.payPalBind.paypal_account
        };
        if (this.unbind) {
          params.type = "paypal.account.bind.code";
        }
        yield API.post(
          "api://base.auth/api/v1/verify-code-send",
          params
        );
        this.$message.success(
          this.$t(
            "change_paypal_account_dialog.paypal_code_send"
          )
        );
        this.to_verify = true;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  bind() {
    return __async(this, null, function* () {
      try {
        const url = `api://base.auth/api/v1/paypal-payment-account`;
        let params = {
          model: "paypal.account.change",
          email: this.payPalBind.paypal_account,
          code: this.payPalVerify.code
        };
        if (this.unbind) {
          params.model = "paypal.account.bind";
          yield API.post(
            url,
            params
          );
        } else {
          yield API.put(
            url,
            params
          );
        }
        this.$message.success(
          this.$t(
            "change_paypal_account_dialog.paypal_bind"
          )
        );
        this._controller.paypal_account = this.payPalBind.paypal_account;
        this.close();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("change-paypal-account-dialog")
], ChangePayPalAccountDialog.prototype, "_change_paypal_account_dialog", 2);
__decorateClass([
  Ref("pay-pal-bind")
], ChangePayPalAccountDialog.prototype, "_pay_pal_bind", 2);
__decorateClass([
  Ref("pay-pal-verify")
], ChangePayPalAccountDialog.prototype, "_pay_pal_verify", 2);
__decorateClass([
  PropSync("controller", { default: {} })
], ChangePayPalAccountDialog.prototype, "_controller", 2);
ChangePayPalAccountDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      UiSubmit
    }
  })
], ChangePayPalAccountDialog);
export {
  ChangePayPalAccountDialog as default
};
